import React from 'react'
import { NavLink } from 'react-router-dom'
import PrivacyPolicy from '../dashboard/PrivacyPolicy'
import TermsAndConditions from '../dashboard/TermsAndConditions'
import Assets from '../../constants/images'

const AuthTermsAndConditionsPage = () => {
    return (
        <div className='auth-card auth-terms-and-conditions-page'>
            <div className="logo-wrapper mb-30 d-block d-xl-none">
                <img src={Assets.Logo} alt="" />
            </div>

            <div className='header'>
                <NavLink className="text-grey d-block mb-2 w-400" to="/signin">Back</NavLink>
                <h1>Terms And Conditions</h1>
            </div>

            <div className='mt-30'>
                <div className='wrapper'>
                    <TermsAndConditions />
                </div>
            </div>
        </div>
    )
}

export default AuthTermsAndConditionsPage